import { Route } from 'react-router-dom';

import { ReservationDetailPage } from './pages/reservation-detail-page.js';
import { ReservationListPage } from './pages/reservation-list-page.js';

/**
 * The Reservations module's routes.
 *
 * Creation and the full lifecycle are handled by the booking flow and PMS sync;
 * the portal lists and inspects the result. Status changes are the next slice.
 */
export function reservationRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/reservations" element={<ReservationListPage />} />
      <Route path="/reservations/:reservationId" element={<ReservationDetailPage />} />
    </>
  );
}
